import {
  LOADING_GETCARDHOLDER_DETAILS,
  GETCARDHOLDER_DETAILS_INVALID_REQUEST,
  GETCARDHOLDER_DETAILS_NOTFOUND,
  GETCARDHOLDER_DETAILS_SUCCESS,
  GETCARDHOLDER_DETAILS_FAILED,
  RESET_GETCARDHOLDER_DETAILS
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCARDHOLDER_DETAILS:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        data: {}
      };
    case GETCARDHOLDER_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        data: action.payload
      };

    case GETCARDHOLDER_DETAILS_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case GETCARDHOLDER_DETAILS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case GETCARDHOLDER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        data: action.payload.cardHolderDetails
          .replace("\n", "")
          .replace('"{', "{")
          .replace('}"}', "}}")
          .replace("000", 0)
      };

    case RESET_GETCARDHOLDER_DETAILS:
      return (state = initialState);

    default:
      return state;
  }
};
